<template>
  <component :is="wrapperComponent" :color="color">
    <v-container v-if="lgAndUp" class="d-flex flex-row align-center" :class="navClass">
      <div
        v-for="(item, i) in items || []"
        :key="(item.title || '') + i"
        :class="gapClass"
      >
        <v-btn
          v-if="! item.children || item.children.length === 0"
          :variant="btnVariant"
          :size="btnSize"
          :rounded="btnRounded"
          :color="btnColor || undefined"
          :density="btnDensity"
          :class="btnClass"
          :active="item.active"
          :href="item.href && item.href !== '#' ? item.href : undefined"
        >
          <template #prepend>
            <v-icon v-if="showIcons && !!item.icon">{{ item.icon }}</v-icon>
          </template>
          <span v-if="!xs || !showIcons || !item.icon">{{ item.title }}</span>
        </v-btn>

        <v-menu v-else>
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              :variant="btnVariant"
              :size="btnSize"
              :rounded="btnRounded"
              :color="btnColor || undefined"
              :density="btnDensity"
              :class="btnClass"
              :active="item.children?.some(a => a.active)"
            >
              <template #prepend>
                <v-icon v-if="showIcons && !!item.icon">{{ item.icon }}</v-icon>
              </template>
              <span v-if="!xs || !showIcons || !item.icon">{{ item.title }}</span>
              <v-icon v-if="!xs">{{ dropdownIcon }}</v-icon>
            </v-btn>
          </template>
          <v-card :class="cardClass" :max-width="cardMaxWidth">
            <v-card-text :class="cardContentClass">
              <v-list class="pa-0">
                <v-hover v-for="(kid) in item.children" :key="kid.title">
                  <template #default="{ isHovering, props: hoverProps }">
                    <v-list-item
                      v-bind="hoverProps"
                      :active="kid.active"
                      class="rounded-lg"
                      :class="listItemClass"
                      link
                      :href="kid.href && kid.href !== '#' ? kid.href : undefined"
                      @click="actionItem(item)"
                    >
                      <template #prepend v-if="showIcons && !!kid.icon">
                        <v-avatar :color="isHovering ? iconBgHoverColor : iconBgColor" rounded="lg">
                          <v-icon
                            :color="isHovering ? iconHoverColor : iconColor"
                            :class="isHovering ? iconHoverClass : iconClass"
                            :icon="kid.icon"
                          />
                        </v-avatar>
                      </template>
                      <v-list-item-title>{{ kid.title }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </v-hover>
              </v-list>
            </v-card-text>
          </v-card>
        </v-menu>
      </div>
    </v-container>
  </component>

</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import { useDisplay } from 'vuetify';
import { MenuItem } from '@/models/menu';
import { useConditionalMenu } from '@/pinia/useConditionalMenu';
import { useMenuStore } from '@/pinia/useMenuStore';

import type { HorizontalNavigationProps } from './HorizontalNavigation.ts';
import { defaults as defaultProps } from './HorizontalNavigation.ts';

const conditionalMenu = useConditionalMenu();
const menuStore = useMenuStore();

const props = withDefaults(defineProps<HorizontalNavigationProps>(), defaultProps);

const items = ref<MenuItem[] | undefined>();
const { xs,lgAndUp } = useDisplay();

const wrapperComponent = computed(() => props.wrapper === 'toolbar' ? 'v-toolbar' : 'div');
const color = computed(() => props.color);

function actionItem(item: MenuItem) {
  if (item.action === 'logout') {
    // Lazy import to avoid strict dependency here
    import('@ui-api3-sdk/api').then(({ auth }) => auth.logout());
  }
}

onMounted(async() => {
  items.value = await conditionalMenu.filter(menuStore.getMenuItems);
});

</script>


